var _path, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAjassaTilaajatahti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m143.27,20.74c.15,0,.27.03.33.05.02.04.06.12.11.26l22.19,68.31c3.87,11.92,14.89,19.92,27.42,19.92h71.82c.15,0,.24.01.29.02.12.13.22.45.2.62-.03.03-.09.1-.22.19l-58.11,42.22c-10.14,7.37-14.35,20.32-10.48,32.24l22.19,68.31c.05.14.06.24.07.28-.09.15-.36.35-.53.39-.04-.02-.12-.06-.25-.15l-58.11-42.22c-4.96-3.6-10.82-5.51-16.95-5.51s-11.99,1.9-16.95,5.51l-58.11,42.22c-.12.09-.2.13-.25.15-.17-.04-.44-.23-.53-.38,0-.04.02-.13.07-.28l22.19-68.31c3.87-11.92-.34-24.87-10.47-32.24l-58.11-42.22c-.12-.09-.19-.15-.22-.19-.02-.17.09-.49.2-.62.04,0,.13-.02.29-.02h71.82c12.53,0,23.55-8.01,27.42-19.92l22.19-68.31c.05-.14.09-.22.11-.26.06-.02.18-.05.33-.05m0-14.19c-5.87,0-11.74,3.37-13.93,10.12l-22.19,68.31c-1.96,6.04-7.58,10.12-13.93,10.12H21.39c-14.19,0-20.09,18.16-8.61,26.5l58.11,42.22c5.13,3.73,7.28,10.34,5.32,16.38l-22.19,68.31c-3.34,10.28,4.83,19.24,13.98,19.24,2.86,0,5.82-.88,8.56-2.86l58.11-42.22c2.57-1.86,5.59-2.8,8.61-2.8s6.04.93,8.61,2.8l58.11,42.22c2.74,1.99,5.7,2.86,8.56,2.86,9.15,0,17.32-8.96,13.98-19.24l-22.19-68.31c-1.96-6.04.19-12.65,5.32-16.38l58.11-42.22c11.48-8.34,5.58-26.5-8.61-26.5h-71.82c-6.35,0-11.97-4.09-13.93-10.12l-22.19-68.31c-2.19-6.75-8.06-10.12-13.93-10.12h0Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 142.93,
    y1: 20.16,
    x2: 142.93,
    y2: 215.5,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8.73
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 89.52,
    y1: 171.66,
    x2: 233.74,
    y2: 104.85,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjassaTilaajatahti);
export default __webpack_public_path__ + "static/media/ajassa_tilaajatahti.e7b0b08856f0d3b50fb637f07cc468b8.svg";
export { ForwardRef as ReactComponent };